export const headCellChipProduct = [
  { id: "", disablePadding: false, label: "" },
  { id: "id", disablePadding: false, label: "Id" },
  { id: "iccid", disablePadding: false, label: "ICCID" },
  { id: "cost", disablePadding: false, label: "Costo" },
  { id: "price", disablePadding: false, label: "Precio" },
  { id: "lote", disablePadding: false, label: "Lote" },
  { id: "createdAt", disablePadding: false, label: "Agregado el" },
  { id: "site", disablePadding: false, label: "Sucursal" },
];
